import styles from "./index.module.css";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { HoverFillButton } from "../button";
import { Close } from "@mui/icons-material";
import ThemeWrapper from "../theme";

type ComponentProps = { className?: string; children?: React.ReactNode };
type OnClickType = React.MouseEventHandler<HTMLButtonElement>;

export type DialogHeaderProps = ComponentProps & {
	onClose?: OnClickType;
	center?: boolean;
};

export type MessageDialogProps = {
	title: React.ReactNode;
	open: boolean;
	onClose: OnClickType;
	showTopCloseButton?: boolean;
	showBottomCloseButton?: boolean;
	additionalButtons?: React.ReactNode;
	children?: React.ReactNode;
};

const DialogCloseButton = ({ onClose }: { onClose: OnClickType }) => {
	return (
		<IconButton className={styles.closeButton} onClick={onClose}>
			<Close />
		</IconButton>
	);
};

export const DialogHeader = ({ onClose, center = true, className, children }: DialogHeaderProps) => {
	return (
		<DialogTitle className={`${styles.dialogHeader} ${className || ""}`} component="div">
			<h2 className={`${styles.dialogTitle} ${center ? styles.center : ""}`}>{children}</h2>
			{onClose && <DialogCloseButton onClose={onClose} />}
		</DialogTitle>
	);
};

export const DialogBody = ({ className, children }: ComponentProps) => {
	return <DialogContent className={`${styles.dialogBody} ${className || ""}`}>{children}</DialogContent>;
};

export const DialogMainDescription = ({ className, children }: ComponentProps) => {
	return <div className={`${styles.mainDescription} ${className || ""}`}>{children}</div>;
};

export const DialogFooter = ({ className, children }: ComponentProps) => {
	return <DialogActions className={`${styles.dialogFooter} ${className || ""}`}>{children}</DialogActions>;
};

export const MessageDialog = ({
	title,
	open,
	onClose,
	showTopCloseButton = true,
	showBottomCloseButton = true,
	additionalButtons,
	children,
}: MessageDialogProps) => {
	return (
		<ThemeWrapper>
			<Dialog open={open} onClose={onClose} maxWidth="xl">
				<DialogHeader onClose={showTopCloseButton ? onClose : undefined}>{title}</DialogHeader>
				<DialogBody className={styles.messageDialogContent}>{children}</DialogBody>
				<DialogFooter>
					{showBottomCloseButton && (
						<HoverFillButton variant="close" onClick={onClose}>
							Close
						</HoverFillButton>
					)}
					{additionalButtons}
				</DialogFooter>
			</Dialog>
		</ThemeWrapper>
	);
};
